import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/style/iconfont.scss";
import { Button, Select, Carousel, CarouselItem } from "element-ui";

Vue.component(Button.name, Button);
Vue.component(Select.name, Select);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.config.productionTip = false;

new Vue({
  router,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
